'use strict';
// hotfix/DAB-3712 //
function validateProductOnInit() {
    let productData = JSON.parse($('#productData').val());
    let isLimitedAdded = JSON.parse($('#isLimitedAdded').val());
    var hasClickAndCollectOnCart = $('#hasClickAndCollect').length > 0 ? JSON.parse($('#hasClickAndCollect').val()) : false;
    var productIsAvailableOnlyCC = $('#availableOnlyCC').length > 0 ? JSON.parse($('#availableOnlyCC').val()) : false;
    var basketHasBigVolumeInside = JSON.parse($('#basketHasBigVolumeInside').val()) || false;
    var uniqueSize = $('#uniqueSize').length > 0 ? $('#uniqueSize') : null;
    let nonPurchasableProducts = productData.nonPurchasableProducts;
    if (productData.isLimited) {
        if (nonPurchasableProducts || isLimitedAdded) {
            $('.variationAttribute').addClass('d-none');
            $('.quantity').addClass('d-none');
            $('.load-islimited').addClass('d-none');
            $('.add-to-cart').prop('disabled', true);
            $('.add-to-cart-global').prop('disabled', true);
            $('.load-islimited-added').removeClass('d-none');
        } else if (!nonPurchasableProducts && !isLimitedAdded) {
            $('.variationAttribute').removeClass('d-none');
            $('.load-islimited').removeClass('d-none');
            $('.load-islimited-added').addClass('d-none');
        }
    } else {
        $('.variationAttribute').removeClass('d-none');
        $('.isLimited').addClass('d-none');
        $('.load-islimited-added').addClass('d-none');
    }

    if (!hasClickAndCollectOnCart && !basketHasBigVolumeInside) {
        $('[click-and-collect-modals]').attr('disabled', false);
    }

    if (hasClickAndCollectOnCart && (uniqueSize && uniqueSize.val() == 1)) {
        var uniqueParent = uniqueSize.parent('.variation-attribute-size');
        uniqueParent.trigger('click');
    }

    if (productIsAvailableOnlyCC && (uniqueSize && uniqueSize.val() == 1)) {
        $('[data-js-display-shipping-methods]').trigger('click');
    }
}
// hotfix/DAB-3712 //
function validateFastShippingMsg() {
    let fastShippingMsgValue = $('#validationDataMsg').val();
    if (fastShippingMsgValue) {
        let fastShippingMsg = JSON.parse(fastShippingMsgValue);
        var today = new Date();
        var time = today.getHours() + ':' + today.getMinutes();
        $('#fastShippingText').remove('#fastShippingText');
        if (fastShippingMsg.timeLimit >= time) {
            $('.stamp-shipment-fastShipping').append('<span id="fastShippingText" class="stamp-shipment-fastShipping">' + fastShippingMsg.msgToday + '</span> ');
        } else {
            $('.stamp-shipment-fastShipping').append('<span id="fastShippingText" class="stamp-shipment-fastShipping">' + fastShippingMsg.msgNextDay + '</span> ');
        }
    }
}

function setAvailableShippingMethods(data) {
    var parser = new DOMParser();
    var response = parser.parseFromString(data, 'text/html');

    $('[data-js-shipping-methods-container]').removeClass('d-none');
    $('[data-js-shipping-methods-accordion]').empty();
    $('[data-js-shipping-methods-hd]').empty();

    var ccMethods = response.querySelector('[data-js-shipping-methods-cc-container]');
    $('[data-js-shipping-methods-accordion]').append(ccMethods);

    var hdMethods = response.querySelector('[data-js-shipping-methods-hd-container]');
    $('[data-js-shipping-methods-hd]').append(hdMethods);
}

function getAvailableShippingMethods(data, searchUrl) {
    $('#shippingMethodsAvailability .modal-content').spinner().start();
    $.ajax({
        url: searchUrl,
        method: 'GET',
        data: data,
        success: function (data) {
            setAvailableShippingMethods(data);
            $.spinner().stop();
        },
        error: function () {
            $('[data-js-shipping-methods-container]').addClass('d-none');

            $('[data-js-shipping-methods-accordion]').empty();
            $('[data-js-shipping-methods-hd]').empty();
            $.spinner().stop();
        }
    });
}

function zoomOutMobile() {
    var viewport = document.querySelector('meta[name="viewport"]');

    if (viewport) {
        viewport.content = 'initial-scale=0.1';
        viewport.content = 'width=1200';
        viewport.content = 'initial-scale=1';
    }
}

$(document).ready(function () {
    $('.slider-mobile-PDP').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        adaptiveHeight: true,
        infinite: true,
        useTransform: true,
        speed: 400
    });
    var currentSlideSliderMobilePDP;
    $('#carousel-pdp-modal').on('shown.bs.modal', function () {
        $('.slider-mobile-PDP-modal').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            dots: false,
            adaptiveHeight: false,
            infinite: true,
            useTransform: false,
            speed: 400,
            initialSlide: currentSlideSliderMobilePDP
        });
        $('.slider-mini-mobile-PDP-modal')
            .on('init', function () {
                $('.slider-mini-mobile-PDP-modal .slick-slide.slick-current').addClass('is-active');
            })
            .slick({
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: false,
                dots: false,
                focusOnSelect: false,
                infinite: false,
                initialSlide: currentSlideSliderMobilePDP
            });
    });

    $('#carousel-pdp-modal').on('hidden.bs.modal', function () {
        $('.slider-mobile-PDP-modal').slick('unslick');
        $('.slider-mini-mobile-PDP-modal').slick('unslick');
        zoomOutMobile();
    });

    $('.nav-mobile-PDP').on('init', function () {
        $('.nav-mobile-PDP .slick-slide.slick-current').addClass('is-active');
    }).slick({
        slidesToShow: 5,
        slidesToScroll: 4,
        arrows: false,
        dots: false,
        focusOnSelect: false,
        infinite: false
    });

    $('.slider-mobile-PDP').on('afterChange', function (event, slick, currentSlide) {
        currentSlideSliderMobilePDP = currentSlide;
        if (currentSlide > 3 && $(window).width() > 599 && $(window).width() < 991) {
            $('.nav-mobile-PDP .slick-list.draggable .slick-track').css('margin-left', '400px');
        } else if (currentSlide < 4 && $(window).width() > 599 && $(window).width() < 991) {
            $('.nav-mobile-PDP .slick-list.draggable .slick-track').css('margin-left', '5px');
        }
        $('.nav-mobile-PDP').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.nav-mobile-PDP .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.nav-mobile-PDP .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.slider-mobile-PDP-modal').on('afterChange', function (event, slick, currentSlide) {
        if (currentSlide > 3 && $(window).width() > 599 && $(window).width() < 991) {
            $('.slider-mini-mobile-PDP-modal .slick-list.draggable .slick-track').css('margin-left', '400px');
        } else if (currentSlide < 4 && $(window).width() > 599 && $(window).width() < 991) {
            $('.slider-mini-mobile-PDP-modal .slick-list.draggable .slick-track').css('margin-left', '5px');
        }
        $('.slider-mini-mobile-PDP-modal').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.slider-mini-mobile-PDP-modal .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.slider-mini-mobile-PDP-modal .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('[data-js-submit-postal-code]').on('click', function (e) {
        e.preventDefault();

        var searchUrl = $('[data-js-submit-postal-code]').attr('data-url');
        var data = {
            pid: $('#productSKU').text(),
            postalCode: $('[data-js-zip-code-shipping]').val(),
            formType: 'Product'
        };

        if (data.postalCode === undefined
            || data.postalCode === null
            || data.postalCode.length < 4
            || data.pid === undefined
            || data.pid === null) {
            return;
        }

        getAvailableShippingMethods(data, searchUrl);
    });

    $('[data-js-display-shipping-methods]').on('click', function (e) {
        e.preventDefault();

        var headerPostalCode = $('[data-js-header-postal-code]');
        let postalCodeValue;

        if (headerPostalCode !== undefined && headerPostalCode !== null && headerPostalCode.length > 0) {
            var modifiedPostalCode = headerPostalCode.text().replace(/[()]/g, '');
            postalCodeValue = modifiedPostalCode;
        } else {
            postalCodeValue = '';
        }

        const havePostalCode = postalCodeValue !== '';
        $('[data-js-zip-code-shipping]').val(postalCodeValue)

        $('[data-js-with-postalcode-msg]').toggleClass('d-none', !havePostalCode);
        $('[data-js-without-postalcode-msg]').toggleClass('d-none', havePostalCode);

        var searchUrl = $('[data-js-submit-postal-code]').attr('data-url');
        var data = {
            pid: $('#productSKU').text(),
            formType: 'Product',
        };

        if (data.pid === undefined
            || data.pid === null) {
            return;
        }

        getAvailableShippingMethods(data, searchUrl);
    })

    $('.nav-mobile-PDP').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.slider-mobile-PDP').slick('slickGoTo', goToSingleSlide);
    });

    $('.slider-mini-mobile-PDP-modal').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.slider-mobile-PDP-modal').slick('slickGoTo', goToSingleSlide);
    });

    $('[data-js-zip-code-shipping]').on('keydown', function (e) {
        if (e.code === 'Enter') {
            $('.modal-shipping-methods-availability-send-btn').trigger('click');
        }
    });
});

$(document).ready(function () {
    /** NET-939 BEGIN **/
    try {
        var productGtmDataValue = $('#productGtmData').val();
        var productGtmData = JSON.parse(productGtmDataValue);
        delete productGtmData.currency;
        var productDetailsGtmEvent = {
            event: 'eec.productDetail',
            ecommerce: {
                detail: {
                    actionField: {
                        list: productGtmData.category
                    },
                    products: []
                }
            }
        };
        productDetailsGtmEvent.ecommerce.detail.products.push(productGtmData);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(productDetailsGtmEvent);
    } catch (e) {
        // Nothing to do here
    }
    /** NET-939 END **/

    $('.add-to-wish-list .fa').on('click', function () {
        $(this).removeClass('fa-heart-o');
        $(this).addClass('fa-heart');
        const urlParams = new URLSearchParams(window.location.search);
        const pidParam = urlParams.get('pid');
        var wishListClickGtm = {
            event: 'trackEvent',
            eventCategory: 'click',
            eventAction: 'body icon',
            eventLabel: `producto '${pidParam}' agregado a favoritos`
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(wishListClickGtm);
    });

    $('body').on('product:afterAttributeSelect', function (e, {
        data
    }) {
        if (data.product && data.product.availableToSellUnified) {
            const { hasLowStockNew, availableOnlyCC, lowStockMessageNewCC, lowStockMessageNewUnified } = data.product.availableToSellUnified;

            let messages = [];

            if (hasLowStockNew) {
                messages.push(`
            <div class="row low-stock-row low-stock-message">
                <div class="col-12">
                    <div class="saving-and-installments-container pull-left">
                        <p class="low-stock">${lowStockMessageNewUnified}</p>
                    </div>
                </div>
            </div>`);
            }

            if (availableOnlyCC) {
                messages.push(`
            <div class="row low-stock-row cc-stock-message">
                <div class="col-12">
                    <div class="saving-and-installments-container pull-left product-cc-msg" data-available-only-cc="true">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                        <p class="low-stock">${lowStockMessageNewCC}</p>
                    </div>
                </div>
            </div>`);
            }

            if (messages.length > 0) {
                $('.product-basic-information .low-stock-row').remove();
                const preAttributesSeparator = $('.pre-attributes-separator.cc-msg-space');
                if (preAttributesSeparator.length) {
                    $(preAttributesSeparator).before(messages.join(''));
                } else {
                    $('.product-detail').prepend(messages.join(''));
                }
            } else {
                $('.product-basic-information .low-stock-row').remove();
            }
        }
    });

    validateProductOnInit();
    validateFastShippingMsg();
    setInterval(validateFastShippingMsg, 60000);
});

$(document).ready(function () {
    const $zoneSelector = $('#zoneSelector');
    const $storeItems = $('[data-store-item]');
    const $noResultsMessage = $('#noResultStores');
    const $storesTotal = $('#storesTotal');
    const $resultsStoresMessage = $('#resultsStoresMessage');
    const $seeAllStores = $('#seeAllStores');
    const $storesAccordion = $('#storesAccordion');

    $zoneSelector.on('change', function () {
        const selectedValue = $zoneSelector.val().toLowerCase();
        let visibleStores = 0;

        $storeItems.each(function () {
            const $store = $(this);
            const storeLocations = $store
                .data('store-location')
                .split(',')
                .map(loc => loc.trim().toLowerCase());

            if (
                selectedValue === '' ||
                storeLocations.includes(selectedValue) ||
                (selectedValue.includes(',') &&
                    selectedValue.split(',').some(val => storeLocations.includes(val.trim())))
            ) {
                $store.show(); // Mostrar tienda
                visibleStores++;
            } else {
                $store.hide(); // Ocultar tienda
            }
        });

        if (visibleStores === 0) {
            $noResultsMessage.removeClass('d-none'); // Mostrar mensaje
            $resultsStoresMessage.addClass('d-none');
            $seeAllStores.addClass('d-none');
        } else {
            $noResultsMessage.addClass('d-none'); // Ocultar mensaje
            $seeAllStores.removeClass('d-none');
            $resultsStoresMessage.removeClass('d-none');
            $storesTotal.text(visibleStores);
        }

        if (visibleStores === 1) {
            $seeAllStores.addClass('d-none');
        }
    });

    $seeAllStores.on('click', function () {
        $seeAllStores.addClass('hide');
        $storesAccordion.addClass('see-more');
    });
});


function adjustQuickView() {
    setTimeout(() => {
        var windowWidth = $(window).width();
        if (windowWidth >= 991) {
            $('.product, .product-tile, .tile-body, .tile-image').hover(function () {
                $(this).find('.quickview-newContainer').css({
                    opacity: '1',
                    'z-index': '15'
                });
            }, function () {
                $(this).find('.quickview-newContainer').css({
                    opacity: '0',
                    'z-index': '0'
                });
            });
        }
    }, 2000);
    // Check if the window width is 991px or above

    // else{
    //     $('.quickview-newContainer').css({
    //         "opacity": "1",
    //         "z-index": "15"
    //     });
    // }
}

adjustQuickView();
